import { createFileRoute } from '@tanstack/react-router'
import { Clock, Mail } from 'lucide-react'

import { ContactForm } from '../components/landing/ContactForm'
import { Footer } from '../components/landing/Footer'
import { Header } from '../components/landing/Header'
import { buildOgMeta } from '../utils/og'

function ContactPage() {
    return (
        <div className="min-h-screen bg-off-white font-sans text-brand-dark">
            <Header />
            <main>
                <section className="relative overflow-hidden bg-off-white py-24">
                    <div className="absolute -right-40 -top-40 h-96 w-96 rounded-full bg-brand-yellow/10 blur-[120px]" />
                    <div className="absolute -bottom-40 -left-40 h-96 w-96 rounded-full bg-primary/10 blur-[120px]" />

                    <div className="relative mx-auto max-w-[1280px] px-6">
                        <div className="mb-16 text-center">
                            <div className="mb-6 inline-block rounded-full bg-brand-yellow px-4 py-1 text-[10px] font-bold uppercase tracking-widest text-brand-dark">
                                Kapcsolat
                            </div>
                            <h1 className="mb-6 text-4xl font-bold leading-tight text-brand-dark md:text-6xl">
                                Lépjen kapcsolatba
                                <br />
                                <span className="text-primary">velünk</span>
                            </h1>
                            <p className="mx-auto max-w-xl text-lg leading-relaxed text-brand-gray">
                                Kérdése van? Írjon nekünk, és hamarosan visszajelzünk.
                            </p>
                        </div>

                        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2">
                            <div className="flex flex-col gap-8">
                                <ContactForm mutation="sendContactForm" />
                            </div>

                            <div className="flex flex-col gap-8 lg:pt-4">
                                <div className="rounded-[2rem] border border-slate-100 bg-white p-10 shadow-xl shadow-slate-100">
                                    <h2 className="mb-8 text-xl font-bold text-brand-dark">
                                        Elérhetőségeink
                                    </h2>
                                    <ul className="flex flex-col gap-6">
                                        <li className="flex items-center gap-4">
                                            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-primary/10">
                                                <Mail className="h-5 w-5 text-primary" />
                                            </div>
                                            <div>
                                                <p className="text-xs font-semibold uppercase tracking-wider text-brand-gray">
                                                    Email
                                                </p>
                                                <a
                                                    href="mailto:info@longyapp.com"
                                                    className="text-base font-semibold text-brand-dark transition-colors hover:text-primary"
                                                >
                                                    info@longyapp.com
                                                </a>
                                            </div>
                                        </li>
                                        {/*<li className="flex items-center gap-4">
                                            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-primary/10">
                                                <Phone className="h-5 w-5 text-primary" />
                                            </div>
                                            <div>
                                                <p className="text-xs font-semibold uppercase tracking-wider text-brand-gray">
                                                    Telefon
                                                </p>
                                                <a
                                                    href="tel:+36301234567"
                                                    className="text-base font-semibold text-brand-dark transition-colors hover:text-primary"
                                                >
                                                    +36 30 123 4567
                                                </a>
                                            </div>
                                        </li>*/}
                                    </ul>
                                </div>

                                <div className="rounded-[2rem] border border-slate-100 bg-white p-10 shadow-xl shadow-slate-100">
                                    <h2 className="mb-8 text-xl font-bold text-brand-dark">
                                        Ügyfélszolgálat
                                    </h2>
                                    <div className="flex items-center gap-4">
                                        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-brand-yellow/20">
                                            <Clock className="h-5 w-5 text-brand-dark" />
                                        </div>
                                        <div>
                                            <p className="text-xs font-semibold uppercase tracking-wider text-brand-gray">
                                                Nyitvatartás
                                            </p>
                                            <p className="text-base font-semibold text-brand-dark">
                                                H–P: 9:00–17:00
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    )
}

export const Route = createFileRoute('/contact')({
    component: ContactPage,
    loader: async ({ context }) => {
        const [, websiteSettings] = await Promise.allSettled([
            context.apiUtils.webContent.getAllPublic.ensureData(),
            context.apiUtils.websiteSettings.getPublic.ensureData(),
        ])
        return {
            websiteSettings: websiteSettings.status === 'fulfilled' ? websiteSettings.value : null,
        }
    },
    head: ({ loaderData }) => ({
        meta: buildOgMeta({
            title: 'Long-Y - Kapcsolat',
            url: `${import.meta.env.VITE_WEB_URL || ''}/contact`,
            websiteSettings: loaderData?.websiteSettings,
        }),
    }),
})
